export default "__VITE_ASSET__7334f244__"